import "/Users/i071496/Dev/Repos/github/v-calendar/node_modules/@vuepress/plugin-nprogress/enhanceAppFile.js"
export default {}